// PGCET MCA Mock 3 — Analytical Ability & Logical Reasoning (questions 56–70), drawn from the Karnataka PGCET 2026 MCA paper
const pgcetmcaAnalyticalReasoning = [
  {
    id: 56,
    question: "In a class exam, Ramya's average mark was 90 per paper. If she had obtained 4 more marks in the Maths paper and 20 more marks in the Physics paper, her average per paper would have been 94. How many papers were there in the exam?",
    options: ["A. 6", "B. 8", "C. 9", "D. 7"],
    answer: "A"
  },
  {
    id: 57,
    question: "In a two-digit number, the digit in the units place is the square of the digit in the tens place, and the difference between the number and the number obtained by interchanging its digits is 54. What is 40% of the original number?",
    options: ["A. 23.4", "B. 15.6", "C. 37.2", "D. 39"],
    answer: "B"
  },
  {
    id: 58,
    question: "Find the missing term in the series: AZ, BY, CX, ?, EV",
    options: ["A. DV", "B. DW", "C. EW", "D. DX"],
    answer: "B"
  },
  {
    id: 59,
    question: "In a certain code language, SHORE is written as PELOB. How is LIGHT written in that code?",
    options: ["A. IFDEQ", "B. IGDEQ", "C. JFDEQ", "D. IFEDQ"],
    answer: "A"
  },
  {
    id: 60,
    question: "No reptiles can fly. All birds can fly. Which of the following must be true?",
    options: ["A. No birds are reptiles", "B. All reptiles can fly", "C. All flying creatures are birds", "D. Some birds are reptiles"],
    answer: "A"
  },
  {
    id: 61,
    question: "Which one of the following numbers is completely divisible by 45?",
    options: ["A. 181566", "B. 331145", "C. 242865", "D. 2023550"],
    answer: "C"
  },
  {
    id: 62,
    question: "A class of 30 boys can play cricket, hockey and/or football. 3 boys play only cricket, 3 play only hockey and 2 play only football. 4 boys play all three games, 11 play football and cricket, and 10 play football and hockey. How many boys play cricket and hockey but not football?",
    options: ["A. 1", "B. 3", "C. 4", "D. 5"],
    answer: "D"
  },
  {
    id: 63,
    question: "Find the odd one out: BDF, HJL, RTW, MOQ",
    options: ["A. BDF", "B. HJL", "C. RTW", "D. MOQ"],
    answer: "C"
  },
  {
    id: 64,
    question: "If 15 August 2023 was a Tuesday, on which day of the week will Independence Day fall in the year 2040?",
    options: ["A. Tuesday", "B. Wednesday", "C. Thursday", "D. Friday"],
    answer: "B"
  },
  {
    id: 65,
    question: `Consider the following equations.
      I: √(1 9/16) = 1 1/4
      II: ∛2744 = 2 × 7`,
    options: [
      "A. I and II are correct",
      "B. I is incorrect, II is correct",
      "C. I is correct, II is incorrect",
      "D. I and II are incorrect"
    ],
    answer: "A"
  },
  {
    id: 66,
    question: "If A ⋆ B means A and B are of the same age, and A − B means B is younger than A, then Himani ⋆ Mahesh − Jay means",
    options: ["A. Himani is younger than Jay", "B. Mahesh is younger than Jay", "C. Jay is the youngest", "D. Jay is the oldest"],
    answer: "C"
  },
  {
    id: 67,
    question: "If the sum of two numbers is 10 and the difference of their squares is 20, the numbers are",
    options: ["A. 8 and 2", "B. 6 and 4", "C. 7 and 3", "D. 5 and 5"],
    answer: "B"
  },
  {
    id: 68,
    question: "A figure consists of a triangle attached to a square such that the triangle points upward. If the figure is rotated 90° clockwise, in which direction will the triangle point?",
    options: ["A. Left", "B. Right", "C. Downward", "D. Upward"],
    answer: "B"
  },
  {
    id: 69,
    question: "Six stores together sold 1500 cellular phones in December 2025, of which store S sold 390. In a pie chart of these sales, the central angle for store S is",
    options: ["A. 99.2°", "B. 93.6°", "C. 105.6°", "D. 97.4°"],
    answer: "B"
  },
  {
    id: 70,
    question: `A researcher is conducting a statistical study on students' academic performance and lifestyle habits. The most appropriate sequence for carrying out the following tasks is:
      (P) Apply statistical methods to summarise and test relationships in the data
      (Q) Design research objectives, variables, sampling plan and data collection instrument
      (R) Interpret findings and draw conclusions
      (S) Collect responses from selected participants
      (T) Classify, code and organise the collected raw data`,
    options: ["A. S → T → Q → P → R", "B. S → T → Q → R → P", "C. Q → S → T → P → R", "D. T → Q → S → P → R"],
    answer: "C"
  }
];

export default pgcetmcaAnalyticalReasoning;
